(() => {
  const SELECTOR = '[data-mbb-how-it-works-hero]';

  class MbbHowItWorksHero {
    constructor(section) {
      if (!section || section.dataset.mbbInitialized === 'true') return;

      this.section = section;
      this.image = section.querySelector('.mbb-how-it-works-hero__image');
      this.content = section.querySelector('[data-mbb-hero-reveal]');
      this.badge = section.querySelector('[data-mbb-step-badge]');

      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.visible = false;
      this.frame = null;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.init();
    }

    init() {
      this.section.dataset.mbbInitialized = 'true';

      this.observeSection();

      if (!this.reducedMotion) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
      }
    }

    observeSection() {
      if (!('IntersectionObserver' in window)) {
        this.visible = true;
        this.section.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            this.visible = entry.isIntersecting;

            if (entry.isIntersecting) {
              this.section.classList.add('is-visible');
              this.update();
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      this.observer.observe(this.section);
    }

    onScroll() {
      if (!this.visible || this.frame) return;

      this.frame = requestAnimationFrame(() => {
        this.update();
        this.frame = null;
      });
    }

    onResize() {
      if (this.frame) cancelAnimationFrame(this.frame);

      this.frame = requestAnimationFrame(() => {
        this.update();
        this.frame = null;
      });
    }

    update() {
      if (this.reducedMotion || !this.visible) return;

      const rect = this.section.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const progress = Math.max(
        -1,
        Math.min(1, (viewportHeight / 2 - rect.top) / viewportHeight)
      );

      if (this.image) {
        this.image.style.setProperty(
          '--mbb-hiw-parallax',
          `${progress * 14}px`
        );
      }

      if (this.badge && window.innerWidth > 749) {
        this.badge.style.setProperty(
          '--mbb-hiw-badge-shift',
          `${progress * -5}px`
        );
      }
    }

    destroy() {
      this.observer?.disconnect();

      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);

      if (this.frame) cancelAnimationFrame(this.frame);

      delete this.section.dataset.mbbInitialized;
    }
  }

  const init = root => {
    const sections = root.matches?.(SELECTOR)
      ? [root]
      : root.querySelectorAll?.(SELECTOR) || [];

    sections.forEach(section => {
      if (section.dataset.mbbInitialized === 'true') return;

      section.mbbHowItWorksHero = new MbbHowItWorksHero(section);
    });
  };

  const start = () => init(document);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    const section = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);

    section?.mbbHowItWorksHero?.destroy();
  });
})();